import { z } from 'zod'

import { TypicalTemplateItemSchema } from './typicalTemplateItem'

export const AnyDependencySchema = z.record(z.string(), TypicalTemplateItemSchema)

export const DependenciesSchema = z.record(z.string(), AnyDependencySchema)
